import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { css } from 'react-emotion';
import { Button, Modal } from '@cimpress/react-components';
import { withTranslation, Trans } from 'react-i18next';
import range from 'lodash/range';

const btnSpacingStyle = css`
  margin-left: 10px;
`;

class TerminateLink extends PureComponent {
  static defaultProps = {};

  static propTypes = {
    termId: PropTypes.string.isRequired,
    latestRevisionId: PropTypes.number.isRequired,
    onTerminateAction: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
    terminated: PropTypes.bool
  };

  state = {
    modalOpened: false
  };

  openModal = () => {
    this.setState({ modalOpened: true });
  };

  closeModal = event => {
    event && event.stopPropagation();
    this.setState({ modalOpened: false });
  };

  render() {
    const { modalOpened } = this.state;
    const { t, termId, latestRevisionId, disabled, terminated, onTerminateAction } = this.props;

    return (
      <Button
        disabled={disabled}
        type="dark"
        title={disabled ? t('createContract:getStarted.sellerInPricingArchV2MessageTooltip') : null}
        className={`btn btn-primary ${btnSpacingStyle}`}
        onClick={disabled ? null : this.openModal}>
        {t('contractActions:terminate')}
        <Modal
          bsStyle="warning"
          show={modalOpened}
          onRequestHide={this.closeModal}
          closeOnOutsideClick={true}
          title={t('terminationWarnings:header')}
          closeButton={true}
          footer={
            <div>
              <div>
                <button className={`btn btn-default ${btnSpacingStyle}`} onClick={this.closeModal}>
                  {t('common:commonWords.cancel')}
                </button>
                <button disabled={disabled} className={`btn btn-danger ${btnSpacingStyle}`} onClick={onTerminateAction}>
                  {!terminated ? t('contractActions:terminateFinal') : t('contractActions:terminated')}
                </button>
              </div>
              {terminated && (
                <a href={`/${termId}/${latestRevisionId + 1}`}>{t('contractActions:goToTerminatedRevision')}</a>
              )}
            </div>
          }>
          <ol>
            {range(5).map(warningIndex => (
              <li>
                <h5>
                  <Trans i18nKey={`terminationWarnings:warning_${warningIndex}`}>Warning Text</Trans>
                </h5>
                <ul>
                  {range(2).map(subWarningIndex => {
                    return (
                      <Trans
                        i18nKey={[
                          `terminationWarnings:warning_${warningIndex}_${subWarningIndex}`,
                          'common:commonWords:blank'
                        ]}>
                        <li>
                          text1<strong>bold text3</strong>text2
                        </li>
                      </Trans>
                    );
                  })}
                </ul>
              </li>
            ))}
          </ol>
        </Modal>
      </Button>
    );
  }
}

export default withTranslation()(TerminateLink);
